var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import i18next from 'i18next';
import entries from 'lodash/entries';
import intersection from 'lodash/intersection';
import omit from 'lodash/omit';
import set from 'lodash/set';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import values from 'lodash/values';
import { PRICE_ID_PATH } from '../../../components/BookingForm/booking-form.helpers';
import { sortAlphaNum } from '../../../components/Courses/courses-helpers';
import { ECourseColumns } from '../../../store/store';
import { BookModelCollection } from '../BookModelCollection';
var CourseTimespanModelCollection = /** @class */ (function (_super) {
    __extends(CourseTimespanModelCollection, _super);
    function CourseTimespanModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseTimespanModelCollection.prototype.getAvailableTimespans = function (filterValues, options) {
        if (filterValues === void 0) { filterValues = {}; }
        if (options === void 0) { options = {}; }
        return this.applyUserFilters(filterValues, [], options).filter(function (m) { return m.max_bookable_places_left >= 1; });
    };
    CourseTimespanModelCollection.prototype.applyUserFilters = function (filterValues, omitFilters, _a) {
        if (omitFilters === void 0) { omitFilters = []; }
        var _b = _a === void 0 ? {} : _a, _c = _b.exclusive, exclusive = _c === void 0 ? true : _c;
        omitFilters = __spreadArray(__spreadArray([], omitFilters), ["search"]);
        return this.filter(function (courseTimespan) {
            var timespanValues = omit(courseTimespan.getNormalizedFilterValues(), omitFilters);
            var filter = omit(filterValues, omitFilters);
            return entries(filter).every(function (_a) {
                var key = _a[0], values = _a[1];
                if (!(values === null || values === void 0 ? void 0 : values.length))
                    return true;
                var predicate = function (filterValue) { var _a; return (_a = timespanValues[key]) === null || _a === void 0 ? void 0 : _a.includes(filterValue); };
                return exclusive ? values.some(predicate) : values.every(predicate);
            });
        });
    };
    CourseTimespanModelCollection.prototype.getFixedCourseIds = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        var allCourses = this.applyUserFilters(filterValues)
            .all()
            .map(function (timespan) { return timespan.get('related.courses.value'); });
        return intersection.apply(void 0, allCourses);
    };
    CourseTimespanModelCollection.prototype.getFixedCourses = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        var courseIds = this.getFixedCourseIds(filterValues);
        return this.modelManager.getCollection('courses').whereIn('id', courseIds);
    };
    CourseTimespanModelCollection.prototype.getFixedPlaceIds = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        var allPlaces = this.applyUserFilters(filterValues)
            .all()
            .map(function (timespan) { return [timespan.get('related.place.value')]; });
        return intersection.apply(void 0, allPlaces);
    };
    CourseTimespanModelCollection.prototype.getFixedPlaces = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        var placeIds = this.getFixedPlaceIds(filterValues);
        return this.modelManager.getCollection('places').whereIn('id', placeIds);
    };
    CourseTimespanModelCollection.prototype.getFixedMonths = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        var months = this.applyUserFilters(filterValues).all().map(function (timespan) { return [
            timespan.getFromAsFilterName(),
        ]; });
        return intersection.apply(void 0, months);
    };
    CourseTimespanModelCollection.prototype.getFixedValues = function () {
        return {
            courses: this.getFixedCourseIds(),
            places: this.getFixedPlaceIds(),
            months: this.getFixedMonths(),
        };
    };
    CourseTimespanModelCollection.prototype.getManyRelationship = function (relationshipName, filterName, filterValues, useServerFilters) {
        var _this = this;
        if (useServerFilters === void 0) { useServerFilters = false; }
        return uniqBy(this.applyUserFilters(filterValues, [filterName])
            .all()
            .reduce(function (models, timespan) {
            var collection = timespan[relationshipName]();
            // If a server filter is false, take only the first related model for each timespan
            if (useServerFilters && _this.options.hasServerFilters === false) {
                var values_1 = timespan.get("related." + relationshipName + ".value");
                var model = collection.findById(values_1[0]);
                if (model)
                    models.push(model);
            }
            // else take all related models
            else
                models.push.apply(models, collection.all());
            return models;
        }, []), function (x) { return x === null || x === void 0 ? void 0 : x.id; });
    };
    CourseTimespanModelCollection.prototype.getOneRelationship = function (relationshipName, filterName, filterValues) {
        return uniqBy(this.applyUserFilters(filterValues, [filterName])
            .all()
            .map(function (timespan) { return timespan[relationshipName](); }), function (x) { return x.id; });
    };
    CourseTimespanModelCollection.prototype.getOneRelationshipFilterSelectOptions = function (relationshipName, filterName, filterValues) {
        return this.getOneRelationship(relationshipName, filterName, filterValues)
            .filter(Boolean)
            .map(function (model) { var _a; return (_a = model.getAsSelectOption) === null || _a === void 0 ? void 0 : _a.call(model, { value: 'name' }); });
    };
    CourseTimespanModelCollection.prototype.getManyRelationshipFilterSelectOptions = function (relationshipName, filterName, filterValues, useServerFilters, _a, otherProps) {
        if (useServerFilters === void 0) { useServerFilters = false; }
        var _b = _a === void 0 ? {} : _a, _c = _b.label, label = _c === void 0 ? 'title' : _c, _d = _b.value, value = _d === void 0 ? 'name' : _d;
        if (otherProps === void 0) { otherProps = {}; }
        return this.getManyRelationship(relationshipName, filterName, filterValues, useServerFilters)
            .filter(Boolean)
            .map(function (model) { var _a; return (_a = model.getAsSelectOption) === null || _a === void 0 ? void 0 : _a.call(model, { label: label, value: value }, otherProps); });
    };
    CourseTimespanModelCollection.prototype.getMonthsFilterSelectOptions = function (filterValues) {
        return uniqBy(this.applyUserFilters(filterValues, ['months'])
            .all()
            .map(function (m) { return ({
            value: m.getFromAsFilterName() || -1,
            label: m.getDateAsTitle('from') || i18next.t('course_table.no_appointments'),
        }); }), function (x) { return x.value; });
    };
    CourseTimespanModelCollection.prototype.getCoursesFilterSelectOptions = function (filterValues) {
        return this.getManyRelationshipFilterSelectOptions('courses', 'courses', filterValues);
    };
    CourseTimespanModelCollection.prototype.getPlacesFilterSelectOptions = function (filterValues) {
        return this.getOneRelationshipFilterSelectOptions('place', 'places', filterValues);
    };
    CourseTimespanModelCollection.prototype.getFilters = function (filterValues, allowedFilters, fixedValues) {
        var _this = this;
        if (fixedValues === void 0) { fixedValues = this.getFixedValues(); }
        var filterMethods = {
            // courses: this.getCoursesFilterSelectOptions,
            // places: this.getPlacesFilterSelectOptions,
            // months: this.getMonthsFilterSelectOptions,
            courses: function () { return _this.modelManager.getCollection("courses").all().map(function (x) { return x.getAsSelectOption({ label: "title", value: "name" }); }); },
            places: function () { return _this.modelManager.getCollection("places").all().map(function (x) { return x.getAsSelectOption({ label: "title", value: "name" }); }); },
            months: function () { return _this.modelManager.getCollection("months").all().map(function (x) { return x.getAsSelectOption({ label: "title", value: "name" }); }); },
        };
        var sortMethods = {
            courses: sortAlphaNum('label'),
            places: function () { return 0; },
            months: function () { return 0; },
        };
        var filters = allowedFilters
            .filter(function (column) {
            return filterMethods[column];
        })
            .map(function (column) { return ({
            name: column,
            options: filterMethods[column]
                .call(_this, filterValues)
                .filter(function (m) { return !fixedValues[column].includes(m.id); })
                .sort(sortMethods[column]),
        }); })
            .filter(function (_a) {
            var name = _a.name;
            return filterMethods[name].call(_this, {}).filter(function (m) { return !fixedValues[name].includes(m.id); }).length > 1;
        });
        return filters;
    };
    CourseTimespanModelCollection.prototype.getRecords = function (filterValues, columns, options) {
        if (options === void 0) { options = {}; }
        var disableInfo = options.disableInfo, dryRun = options.dryRun, placement = options.placement, titleKey = options.titleKey, fixedColumns = options.fixedColumns, maxPlacesThreshold = options.maxPlacesThreshold;
        var filteredCollection = this.applyUserFilters(filterValues);
        var courses = this.getFixedValues().courses;
        var dataColumns = uniq(__spreadArray(__spreadArray([], columns), [
            ECourseColumns.INFO,
            ECourseColumns.PRICE,
            ECourseColumns.BOOKLINK,
            ECourseColumns.TIMESPAN,
        ]));
        var recordsArray = filteredCollection.all();
        var records = recordsArray.map(function (timespan, i, self) {
            return timespan.prepareAsRow({
                dryRun: dryRun,
                disableInfo: disableInfo,
                fixedColumns: fixedColumns,
                dataColumns: dataColumns,
                fixedCourses: options.fixedCourses || courses,
                placement: placement,
                titleKey: titleKey,
                maxPlacesThreshold: maxPlacesThreshold
            });
        });
        // records = records.sort(sortAlphaNum('sortKey'));
        return records;
    };
    CourseTimespanModelCollection.prototype.getAsSelectOptions = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.placement, placement = _c === void 0 ? 'bookcart' : _c, _d = _b.courses, courses = _d === void 0 ? [] : _d, _e = _b.price_id, price_id = _e === void 0 ? null : _e, _f = _b.label, label = _f === void 0 ? '' : _f;
        var courseIds = !courses.length ? [] : this.getFixedCourseIds({ courses: courses, });
        return values(this.all().reduce(function (optionGroups, courseTimespan) {
            var fromValue = courseTimespan.getFromAsFilterName() || '';
            var fromTitle = courseTimespan.getDateAsTitle('from') || '';
            var id = courseTimespan.get('id');
            var placesLeft = courseTimespan.get('max_bookable_places_left');
            var noPlacesLeft = !placesLeft || placesLeft <= 0;
            var option = {
                label: courseTimespan.getAsTitle(courseIds, { placement: placement, titleKey: label }, set({ isAdminForm: _this.options.isAdminIntegration }, PRICE_ID_PATH, price_id)),
                value: '' + id,
                disabled: !_this.options.disableAvailabilityCheck && noPlacesLeft,
            };
            if (!fromValue) {
                optionGroups[id] = option;
                return optionGroups;
            }
            optionGroups[fromValue] = optionGroups[fromValue] || {
                label: fromTitle,
                value: fromValue,
                children: [],
            };
            optionGroups[fromValue].children.push(option);
            return optionGroups;
        }, {})).sort(function (one, two) {
            return one.value - two.value;
        });
    };
    CourseTimespanModelCollection.prototype.getCourses = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        return this.getManyRelationship('courses', 'courses', filterValues, true);
    };
    CourseTimespanModelCollection.prototype.getPlaces = function (filterValues) {
        if (filterValues === void 0) { filterValues = {}; }
        return this.getOneRelationship('place', 'places', filterValues);
    };
    return CourseTimespanModelCollection;
}(BookModelCollection));
export { CourseTimespanModelCollection };
